"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Detail = function Detail(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M15.182 8.81805C14.4458 8.08187 13.4772 7.62373 12.4411 7.52168C11.405 7.41963 10.3656 7.67998 9.49996 8.25838C8.63431 8.83677 7.996 9.69743 7.69378 10.6937C7.39156 11.69 7.44413 12.7602 7.84253 13.7221C8.24093 14.6839 8.96052 15.4779 9.87869 15.9686C10.7968 16.4594 11.8568 16.6166 12.8779 16.4135C13.899 16.2104 14.8181 15.6596 15.4785 14.8548C16.139 14.05 16.5 13.0411 16.5 12C16.5016 11.4089 16.386 10.8232 16.1597 10.277C15.9335 9.73084 15.6012 9.23494 15.182 8.81805Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M6 6.5C5.86739 6.5 5.74021 6.44732 5.64645 6.35355C5.55268 6.25979 5.5 6.13261 5.5 6C5.5 5.86739 5.55268 5.74021 5.64645 5.64645C5.74021 5.55268 5.86739 5.5 6 5.5H8C8.13261 5.5 8.25979 5.55268 8.35355 5.64645C8.44732 5.74021 8.5 5.86739 8.5 6C8.5 6.13261 8.44732 6.25979 8.35355 6.35355C8.25979 6.44732 8.13261 6.5 8 6.5H6Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M6 8.5C5.86739 8.5 5.74021 8.44732 5.64645 8.35355C5.55268 8.25979 5.5 8.13261 5.5 8V6C5.5 5.86739 5.55268 5.74021 5.64645 5.64645C5.74021 5.55268 5.86739 5.5 6 5.5C6.13261 5.5 6.25979 5.55268 6.35355 5.64645C6.44732 5.74021 6.5 5.86739 6.5 6V8C6.5 8.13261 6.44732 8.25979 6.35355 8.35355C6.25979 8.44732 6.13261 8.5 6 8.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M6 18.5C5.86739 18.5 5.74021 18.4473 5.64645 18.3536C5.55268 18.2598 5.5 18.1326 5.5 18C5.5 17.8674 5.55268 17.7402 5.64645 17.6464C5.74021 17.5527 5.86739 17.5 6 17.5H8C8.13261 17.5 8.25979 17.5527 8.35355 17.6464C8.44732 17.7402 8.5 17.8674 8.5 18C8.5 18.1326 8.44732 18.2598 8.35355 18.3536C8.25979 18.4473 8.13261 18.5 8 18.5H6Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M6 18.5C5.86739 18.5 5.74021 18.4473 5.64645 18.3536C5.55268 18.2598 5.5 18.1326 5.5 18V16C5.5 15.8674 5.55268 15.7402 5.64645 15.6464C5.74021 15.5527 5.86739 15.5 6 15.5C6.13261 15.5 6.25979 15.5527 6.35355 15.6464C6.44732 15.7402 6.5 15.8674 6.5 16V18C6.5 18.1326 6.44732 18.2598 6.35355 18.3536C6.25979 18.4473 6.13261 18.5 6 18.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18 6.5H16C15.8674 6.5 15.7402 6.44732 15.6464 6.35355C15.5527 6.25979 15.5 6.13261 15.5 6C15.5 5.86739 15.5527 5.74021 15.6464 5.64645C15.7402 5.55268 15.8674 5.5 16 5.5H18C18.1326 5.5 18.2598 5.55268 18.3536 5.64645C18.4473 5.74021 18.5 5.86739 18.5 6C18.5 6.13261 18.4473 6.25979 18.3536 6.35355C18.2598 6.44732 18.1326 6.5 18 6.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18 8.5C17.8674 8.5 17.7402 8.44732 17.6464 8.35355C17.5527 8.25979 17.5 8.13261 17.5 8V6C17.5 5.86739 17.5527 5.74021 17.6464 5.64645C17.7402 5.55268 17.8674 5.5 18 5.5C18.1326 5.5 18.2598 5.55268 18.3536 5.64645C18.4473 5.74021 18.5 5.86739 18.5 6V8C18.5 8.13261 18.4473 8.25979 18.3536 8.35355C18.2598 8.44732 18.1326 8.5 18 8.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18 18.5H16C15.8674 18.5 15.7402 18.4473 15.6464 18.3536C15.5527 18.2598 15.5 18.1326 15.5 18C15.5 17.8674 15.5527 17.7402 15.6464 17.6464C15.7402 17.5527 15.8674 17.5 16 17.5H18C18.1326 17.5 18.2598 17.5527 18.3536 17.6464C18.4473 17.7402 18.5 17.8674 18.5 18C18.5 18.1326 18.4473 18.2598 18.3536 18.3536C18.2598 18.4473 18.1326 18.5 18 18.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18 18.5C17.8674 18.5 17.7402 18.4473 17.6464 18.3536C17.5527 18.2598 17.5 18.1326 17.5 18V16C17.5 15.8674 17.5527 15.7402 17.6464 15.6464C17.7402 15.5527 17.8674 15.5 18 15.5C18.1326 15.5 18.2598 15.5527 18.3536 15.6464C18.4473 15.7402 18.5 15.8674 18.5 16V18C18.5 18.1326 18.4473 18.2598 18.3536 18.3536C18.2598 18.4473 18.1326 18.5 18 18.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M23.159 7.57812C22.1299 7.77428 21.2015 8.32321 20.5337 9.13033C19.8659 9.93746 19.5005 10.9522 19.5005 11.9998C19.5005 13.0474 19.8659 14.0622 20.5337 14.8693C21.2015 15.6764 22.1299 16.2254 23.159 16.4215C24.2803 13.5804 24.2803 10.4193 23.159 7.57812Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M3.182 8.81782C2.54494 8.17744 1.72873 7.74521 0.841027 7.57812C-0.280342 10.4193 -0.280342 13.5804 0.841027 16.4215C1.72873 16.2544 2.54494 15.8222 3.182 15.1818C4.02589 14.3379 4.49998 13.1933 4.49998 11.9999C4.49998 10.8064 4.02589 9.66184 3.182 8.81793V8.81782Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.foregroundColor
  }))));
};

Detail.defaultProps = {
  altText: "Detail",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
Detail.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Detail;
exports.default = _default;